import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type {
  IActiveAppResponse,
  IActiveDPResponse,
  IActivePublisherResponse
} from '@shared/api/services/inventory.service';

export interface InventoryState {
  activeApps: IActiveAppResponse[];
  activeDemandPartners: IActiveDPResponse[];
  activePublishers: IActivePublisherResponse[];
}

const initialState: InventoryState = {
  activeApps: [],
  activeDemandPartners: [],
  activePublishers: []
};

const inventorySlice = createSlice({
  name: 'inventory',
  initialState,
  reducers: {
    setActiveApps: (state, action: PayloadAction<IActiveAppResponse[]>) => {
      state.activeApps = action.payload;
    },
    setActiveDemandPartners: (state, action: PayloadAction<IActiveDPResponse[]>) => {
      state.activeDemandPartners = action.payload;
    },
    setActivePublishers: (state, action: PayloadAction<IActivePublisherResponse[]>) => {
      state.activePublishers = action.payload;
    },
    resetInventoryState: () => initialState
  }
});

export const { setActiveApps, setActiveDemandPartners, setActivePublishers, resetInventoryState } =
  inventorySlice.actions;

export default inventorySlice.reducer;
